export default function Stars({ n = 5 }) {
  return (
    <span>
      {[1, 2, 3, 4, 5].map(i => (
        <span key={i} style={{ color: i <= n ? "#F2A623" : "#e5e7eb", fontSize: 15.5 }}>★</span>
      ))}
    </span>
  );
}
